const LateCheckoutIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    {...props}
  >
    <path
      d="M9.45834 0.125C14.6354 0.125 18.8333 4.32292 18.8333 9.5H21.9583L17.9063 13.5521L17.8333 13.6979L13.625 9.5H16.75C16.75 5.46875 13.4896 2.20833 9.45834 2.20833C5.42709 2.20833 2.16667 5.46875 2.16667 9.5C2.16667 13.5312 5.42709 16.7917 9.45834 16.7917C11.4688 16.7917 13.2917 15.9688 14.6042 14.6458L16.0833 16.125C14.3854 17.8229 12.0521 18.875 9.45834 18.875C4.28125 18.875 0.0833359 14.6771 0.0833359 9.5C0.0833359 4.32292 4.28125 0.125 9.45834 0.125ZM10.5 5.33333V10.5417L6.04167 13.1875L5.29167 11.9271L8.9375 9.76042V5.33333H10.5Z"
      fill="#EC4899"
    />
  </svg>
)

export default LateCheckoutIcon
